(function(){
  class SCCSlider extends HTMLElement {
    constructor(){
      super();
      this.currentSlide = 0;
      this.itemsPerSlide = 6;
    }
    connectedCallback(){
      this.track = this.querySelector('[data-scc-track]');
      this.prevBtn = this.querySelector('[data-scc-prev]');
      this.nextBtn = this.querySelector('[data-scc-next]');
      this.dotsContainer = this.querySelector('[data-scc-dots]');
      this.items = this.track ? this.track.querySelectorAll('.scc-item') : [];

      this.updateItemsPerSlide();
      this.createDots();
      this.updateSlider();
      this.setupEventListeners();

      window.addEventListener('resize', () => {
        this.updateItemsPerSlide();
        this.createDots();
        this.updateSlider();
      });
    }
    updateItemsPerSlide(){
      // Desktop slider behavior only; mobile uses native scroll via CSS
      this.itemsPerSlide = 6;
    }
    get totalSlides(){
      if (!this.items) return 0;
      return Math.ceil(this.items.length / this.itemsPerSlide);
    }
    setupEventListeners(){
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.prevSlide());
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.nextSlide());
    }
    createDots(){
      if (!this.dotsContainer) return;
      this.dotsContainer.innerHTML = '';
      for (let i = 0; i < this.totalSlides; i++){
        const dot = document.createElement('button');
        dot.className = 'scc-dot';
        dot.setAttribute('aria-label', `Go to slide ${i+1}`);
        dot.addEventListener('click', () => this.goToSlide(i));
        this.dotsContainer.appendChild(dot);
      }
    }
    updateSlider(){
      if (!this.track) return;
      const translateX = -(this.currentSlide * 100);
      this.track.style.transform = `translateX(${translateX}%)`;
      if (this.prevBtn) this.prevBtn.disabled = this.currentSlide === 0;
      if (this.nextBtn) this.nextBtn.disabled = this.currentSlide >= this.totalSlides - 1;
      if (this.dotsContainer){
        const dots = this.dotsContainer.querySelectorAll('.scc-dot');
        dots.forEach((dot, index) => dot.classList.toggle('active', index === this.currentSlide));
      }
    }
    prevSlide(){ if (this.currentSlide > 0){ this.currentSlide--; this.updateSlider(); } }
    nextSlide(){ if (this.currentSlide < this.totalSlides - 1){ this.currentSlide++; this.updateSlider(); } }
    goToSlide(index){ this.currentSlide = index; this.updateSlider(); }
  }

  customElements.define('slider-collection-categories', SCCSlider);
})();
